(function() {
  'use strict';

  /* ===================== PRODUCT DATA ===================== */
  var PRODUCTS = {
    unflavored: {
      variantId: '42264734302302',
      sellingPlan: '6281822302',
      oneTimePrice: '$34.99',
      subscribePrice: '$27.99',
      images: [
        'https://cdn.shopify.com/s/files/1/0645/6465/files/Lean-Creatine-20oz-MainImage.jpg?v=1767629910',
        'https://cdn.shopify.com/s/files/1/0645/6465/files/Lean-Creatine-20oz-RightSide.jpg?v=1767631194',
        'https://cdn.shopify.com/s/files/1/0645/6465/files/1-LeanCreatine-ScienceBacked_0105d872-d659-4f94-8b3c-3b0e24d46b28.jpg?v=1767631624',
        'https://cdn.shopify.com/s/files/1/0645/6465/files/2-LeanCreatine-Bloating.jpg?v=1767631624',
        'https://cdn.shopify.com/s/files/1/0645/6465/files/3-LeanCreatine-absorption.jpg?v=1767631624',
        'https://cdn.shopify.com/s/files/1/0645/6465/files/6-LeanCreatine-LesstoScoop.jpg?v=1767721679',
        'https://cdn.shopify.com/s/files/1/0645/6465/files/5-LeanCreatine-Formula.jpg?v=1767721679',
        'https://cdn.shopify.com/s/files/1/0645/6465/files/6-LeanCreatine-Gains.jpg?v=1767721679'
      ]
    },
    raspberry: {
      variantId: '42264742920286',
      sellingPlan: '6281822302',
      oneTimePrice: '$34.99',
      subscribePrice: '$27.99',
      images: [
        'https://cdn.shopify.com/s/files/1/0645/6465/files/Lean-Creatine-RaspberryLime-20oz-MainImage.jpg?v=1767629945',
        'https://cdn.shopify.com/s/files/1/0645/6465/files/Lean-Creatine-RaspberryLime-20oz-RightSide.jpg?v=1767631177',
        'https://cdn.shopify.com/s/files/1/0645/6465/files/1-LeanCreatine-RaspberryLime-ScienceBacked_c9597a0e-a3d6-401b-9e53-118d76ba5f27.jpg?v=1767631641',
        'https://cdn.shopify.com/s/files/1/0645/6465/files/2-LeanCreatine-RaspberryLime-Bloating.jpg?v=1767631641',
        'https://cdn.shopify.com/s/files/1/0645/6465/files/3-LeanCreatine-RaspberryLime-absorption.jpg?v=1767631641',
        'https://cdn.shopify.com/s/files/1/0645/6465/files/6-LeanCreatine-RaspberryLime-LesstoScoop.jpg?v=1767721455',
        'https://cdn.shopify.com/s/files/1/0645/6465/files/5-LeanCreatine-RaspberryLime-Formula.jpg?v=1767721455',
        'https://cdn.shopify.com/s/files/1/0645/6465/files/6-LeanCreatine-RaspberryLime-Gains.jpg?v=1767721455'
      ]
    }
  };

  /* ===================== STATE ===================== */
  var state = {
    flavor: 'unflavored',
    purchaseType: 'onetime',
    currentImageIndex: 0,
    thumbnailOffset: 0
  };
  var VISIBLE_THUMBS = 5;

  /* ===================== HELPERS ===================== */
  function getProduct() {
    return PRODUCTS[state.flavor];
  }

  function getPrice() {
    var p = getProduct();
    return state.purchaseType === 'subscribe' ? p.subscribePrice : p.oneTimePrice;
  }

  function getStrikePrice() {
    return getProduct().oneTimePrice;
  }

  /* ===================== UI UPDATES ===================== */
  function updateAllPrices() {
    var price = getPrice();

    var cartBtn = document.getElementById('add-to-cart-btn');
    if (cartBtn) cartBtn.textContent = 'ADD TO CART - ' + price;

    document.querySelectorAll('[data-buy-now]').forEach(function(btn) {
      var nodes = btn.childNodes;
      for (var i = nodes.length - 1; i >= 0; i--) {
        if (nodes[i].nodeType === 3 && nodes[i].textContent.trim()) {
          nodes[i].textContent = 'BUY NOW - ' + price;
          break;
        }
      }
    });

    document.querySelectorAll('button').forEach(function(btn) {
      if (btn.textContent.trim().startsWith('Order Now')) {
        var nodes = btn.childNodes;
        for (var i = nodes.length - 1; i >= 0; i--) {
          if (nodes[i].nodeType === 3 && nodes[i].textContent.trim()) {
            nodes[i].textContent = 'Order Now - ' + price;
            break;
          }
        }
      }
    });

    var onetimeBtn = document.getElementById('btn-onetime');
    if (onetimeBtn) {
      var priceEl = onetimeBtn.querySelector('.text-xl');
      if (priceEl) priceEl.textContent = getProduct().oneTimePrice;
    }

    var subBtn = document.getElementById('btn-subscribe');
    if (subBtn) {
      var subPrice = subBtn.querySelector('.text-xl');
      if (subPrice) subPrice.textContent = getProduct().subscribePrice;
      var strikeEl = subBtn.querySelector('.line-through');
      if (strikeEl) strikeEl.textContent = getProduct().oneTimePrice;
      var recurringEl = null;
      subBtn.querySelectorAll('.text-xs').forEach(function(el) {
        if (el.textContent.includes('/month')) recurringEl = el;
      });
      if (recurringEl) recurringEl.textContent = 'Then ' + getProduct().subscribePrice + '/month \u2022 Cancel anytime';
    }

    document.querySelectorAll('p').forEach(function(p) {
      if (p.textContent.includes('120 servings for just')) {
        p.textContent = p.textContent.replace(/\$[\d.]+/, price);
      }
    });
  }

  function updateFlavorButtons() {
    var btnU = document.getElementById('btn-unflavored');
    var btnR = document.getElementById('btn-raspberry');
    if (state.flavor === 'unflavored') {
      btnU.className = btnU.className.replace('border-[#C7C7C7] hover:border-[#1A90FF]', 'border-[#1A90FF] bg-[#F2F2F2]');
      if (!btnU.className.includes('border-[#1A90FF]')) btnU.className += ' border-[#1A90FF] bg-[#F2F2F2]';
      btnR.className = btnR.className.replace('border-[#1A90FF] bg-[#F2F2F2]', 'border-[#C7C7C7] hover:border-[#1A90FF]');
    } else {
      btnR.className = btnR.className.replace('border-[#C7C7C7] hover:border-[#1A90FF]', 'border-[#1A90FF] bg-[#F2F2F2]');
      if (!btnR.className.includes('border-[#1A90FF]')) btnR.className += ' border-[#1A90FF] bg-[#F2F2F2]';
      btnU.className = btnU.className.replace('border-[#1A90FF] bg-[#F2F2F2]', 'border-[#C7C7C7] hover:border-[#1A90FF]');
    }
  }

  function updatePurchaseButtons() {
    var btnO = document.getElementById('btn-onetime');
    var btnS = document.getElementById('btn-subscribe');

    var dotO = btnO.querySelector('.size-5.rounded-full');
    var dotS = btnS.querySelector('.size-5.rounded-full');

    if (state.purchaseType === 'onetime') {
      btnO.className = 'w-full p-3 rounded-lg border-2 transition-all text-left border-[#1A90FF] bg-[#F2F2F2]';
      btnS.className = 'w-full p-3 rounded-lg border-2 transition-all text-left border-[#C7C7C7] hover:border-[#1A90FF]';
      if (dotO) {
        dotO.className = 'size-5 rounded-full border-2 flex items-center justify-center border-[#1A90FF]';
        dotO.innerHTML = '<div class="size-2.5 rounded-full bg-[#1A90FF]"></div>';
      }
      if (dotS) {
        dotS.className = 'size-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 border-[#C7C7C7]';
        dotS.innerHTML = '';
      }
    } else {
      btnS.className = 'w-full p-3 rounded-lg border-2 transition-all text-left border-[#1A90FF] bg-[#F2F2F2]';
      btnO.className = 'w-full p-3 rounded-lg border-2 transition-all text-left border-[#C7C7C7] hover:border-[#1A90FF]';
      if (dotS) {
        dotS.className = 'size-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 border-[#1A90FF]';
        dotS.innerHTML = '<div class="size-2.5 rounded-full bg-[#1A90FF]"></div>';
      }
      if (dotO) {
        dotO.className = 'size-5 rounded-full border-2 flex items-center justify-center border-[#C7C7C7]';
        dotO.innerHTML = '';
      }
    }
  }

  /* ===================== IMAGE GALLERY ===================== */
  function updateGallery() {
    var images = getProduct().images;
    var idx = state.currentImageIndex;
    if (idx >= images.length) { idx = 0; state.currentImageIndex = 0; }

    var mainImg = document.getElementById('main-product-image');
    if (mainImg) mainImg.src = images[idx];

    // Clamp thumbnail offset
    var maxOffset = Math.max(0, images.length - VISIBLE_THUMBS);
    if (state.thumbnailOffset > maxOffset) state.thumbnailOffset = maxOffset;
    if (state.thumbnailOffset < 0) state.thumbnailOffset = 0;

    var container = document.getElementById('thumbnail-container');
    if (container) {
      var thumbBtns = container.querySelectorAll('button');
      thumbBtns.forEach(function(btn, i) {
        var imgIndex = i + state.thumbnailOffset;
        if (imgIndex < images.length) {
          btn.style.display = '';
          var img = btn.querySelector('img');
          if (img) {
            img.src = images[imgIndex];
            img.alt = (state.flavor === 'unflavored' ? 'Unflavored' : 'Raspberry Lime') + ' thumbnail ' + (imgIndex + 1);
          }
          if (imgIndex === idx) {
            btn.className = btn.className.replace('border-[#C7C7C7] hover:border-[#1A90FF]', 'border-[#1A90FF]');
            if (!btn.className.includes('border-[#1A90FF]')) {
              btn.className = btn.className.replace('border-[#C7C7C7]', 'border-[#1A90FF]');
            }
          } else {
            btn.className = btn.className.replace('border-[#1A90FF]', 'border-[#C7C7C7] hover:border-[#1A90FF]');
          }
        } else {
          btn.style.display = 'none';
        }
      });
    }

    // Show/hide scroll buttons
    var scrollRightBtn = document.getElementById('scroll-thumbnails-btn');
    if (scrollRightBtn) {
      scrollRightBtn.style.display = (images.length > VISIBLE_THUMBS && state.thumbnailOffset < maxOffset) ? '' : 'none';
    }
    var scrollLeftBtn = document.getElementById('scroll-thumbnails-left-btn');
    if (scrollLeftBtn) {
      scrollLeftBtn.style.display = (state.thumbnailOffset > 0) ? '' : 'none';
    }

    var dots = document.getElementById('dot-indicators');
    if (dots) {
      var dotBtns = dots.querySelectorAll('button');
      dotBtns.forEach(function(dot, i) {
        if (i < images.length) {
          dot.style.display = '';
          if (i === idx) {
            dot.className = 'size-1.5 rounded-full transition-all bg-[#1A90FF] w-6';
          } else {
            dot.className = 'size-1.5 rounded-full transition-all bg-white/60';
          }
        } else {
          dot.style.display = 'none';
        }
      });
    }
  }

  /* ===================== CART / CHECKOUT ===================== */
  var SPINNER_SVG = '<svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity=".25"></circle><path fill="currentColor" d="M4 12a8 8 0 018-8v3a5 5 0 00-5 5H4z"></path></svg>';

  function setCartButtonLoading(loading) {
    var btn = document.getElementById('add-to-cart-btn');
    if (!btn) return;
    if (loading) {
      btn.disabled = true;
      btn.dataset.originalText = btn.textContent;
      btn.innerHTML = SPINNER_SVG + ' Adding...';
      btn.style.opacity = '0.7';
      btn.style.pointerEvents = 'none';
    } else {
      btn.disabled = false;
      btn.textContent = btn.dataset.originalText || ('ADD TO CART - ' + getPrice());
      btn.style.opacity = '';
      btn.style.pointerEvents = '';
    }
  }

  function addToCart() {
    var product = getProduct();
    var item = {
      id: String(product.variantId),
      quantity: 1,
      selling_plan: null,
      properties: {}
    };

    if (state.purchaseType === 'subscribe') {
      item.selling_plan = String(product.sellingPlan);
    }

    setCartButtonLoading(true);

    // Use NS Hybrid Cart API if available (opens the cart drawer)
    if (window.NSHybridCart && window.NSHybridCart.cartAPI) {
      window.NSHybridCart.loadCart().then(function() {
        return window.NSHybridCart.cartAPI.addToCart(item);
      }).then(function() {
        setCartButtonLoading(false);
        window.NSHybridCart.open();
      }).catch(function(err) {
        console.error('Add to cart failed:', err);
        setCartButtonLoading(false);
        alert('Something went wrong adding to cart. Please try again.');
      });
      return;
    }

    // Fallback: standard AJAX add-to-cart with redirect
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Cart error: ' + res.status);
      return res.json();
    })
    .then(function() {
      setCartButtonLoading(false);
      window.location.href = '/cart';
    })
    .catch(function(err) {
      console.error('Add to cart failed:', err);
      setCartButtonLoading(false);
      alert('Something went wrong adding to cart. Please try again.');
    });
  }

  /* ===================== VIDEO PLAYERS ===================== */
  function initVideos() {
    document.querySelectorAll('video').forEach(function(video) {
      video.muted = true;
      video.autoplay = true;
      video.playsInline = true;
      video.play().catch(function() {});

      var wrapper = video.closest('.group');
      if (!wrapper) return;
      var overlay = wrapper.querySelector('.bg-black\\/20');
      var playIcon = wrapper.querySelector('.bg-white\\/90.rounded-full.p-4');
      var muteBtn = wrapper.querySelector('button');

      wrapper.addEventListener('click', function(e) {
        if (e.target.closest('button') === muteBtn) return;
        if (video.paused) {
          video.play();
          if (overlay) overlay.style.opacity = '0';
          if (playIcon) playIcon.style.display = 'none';
        } else {
          video.pause();
          if (overlay) overlay.style.opacity = '1';
          if (playIcon) playIcon.style.display = '';
        }
      });

      if (muteBtn) {
        muteBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          video.muted = !video.muted;
          var svg = muteBtn.querySelector('svg');
          if (svg) {
            if (video.muted) {
              svg.innerHTML = '<path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"></path><line x1="22" x2="16" y1="9" y2="15"></line><line x1="16" x2="22" y1="9" y2="15"></line>';
            } else {
              svg.innerHTML = '<path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"></path><path d="M16 9a5 5 0 0 1 0 6"></path><path d="M19.364 18.364a9 9 0 0 0 0-12.728"></path>';
            }
          }
        });
      }

      video.addEventListener('playing', function() {
        if (overlay) overlay.style.opacity = '0';
        if (playIcon) playIcon.style.display = 'none';
      });
    });
  }

  /* ===================== FAQ ACCORDION ===================== */
  function initFAQ() {
    document.querySelectorAll('.faq-trigger').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var content = this.parentElement.querySelector('.faq-content');
        var chevron = this.querySelector('.faq-chevron');
        var isOpen = content.style.display !== 'none';

        if (isOpen) {
          content.style.display = 'none';
          if (chevron) chevron.style.transform = 'translateY(2px) rotate(0deg)';
          this.setAttribute('aria-expanded', 'false');
        } else {
          content.style.display = 'block';
          if (chevron) chevron.style.transform = 'translateY(2px) rotate(180deg)';
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ===================== SMOOTH SCROLL ===================== */
  function initScrollButtons() {
    document.querySelectorAll('[data-buy-now]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.getElementById('flavor-section');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    document.querySelectorAll('button').forEach(function(btn) {
      if (btn.textContent.trim().startsWith('Order Now')) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          var target = document.getElementById('flavor-section');
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    });

    document.querySelectorAll('[data-scroll-to]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.getElementById(this.getAttribute('data-scroll-to'));
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ===================== FLOATING CART BADGE ===================== */
  function updateCartBadge() {
    var badge = document.getElementById('floating-cart-count');
    if (!badge) return;
    var count = parseInt(badge.textContent, 10) || 0;
    badge.style.display = count > 0 ? '' : 'none';
  }

  function initCartBadge() {
    updateCartBadge();
    // Watch for NS Hybrid Cart updating the count automatically
    var badge = document.getElementById('floating-cart-count');
    if (badge && typeof MutationObserver !== 'undefined') {
      new MutationObserver(updateCartBadge).observe(badge, { childList: true, characterData: true, subtree: true });
    }
  }

  /* ===================== INIT ===================== */
  function init() {
    initCartBadge();
    document.getElementById('btn-unflavored').addEventListener('click', function() {
      state.flavor = 'unflavored';
      state.currentImageIndex = 0;
      state.thumbnailOffset = 0;
      updateFlavorButtons();
      updateGallery();
      updateAllPrices();
    });
    document.getElementById('btn-raspberry').addEventListener('click', function() {
      state.flavor = 'raspberry';
      state.currentImageIndex = 0;
      state.thumbnailOffset = 0;
      updateFlavorButtons();
      updateGallery();
      updateAllPrices();
    });

    document.getElementById('btn-onetime').addEventListener('click', function() {
      state.purchaseType = 'onetime';
      updatePurchaseButtons();
      updateAllPrices();
    });
    document.getElementById('btn-subscribe').addEventListener('click', function() {
      state.purchaseType = 'subscribe';
      updatePurchaseButtons();
      updateAllPrices();
    });

    document.getElementById('add-to-cart-btn').addEventListener('click', function(e) {
      e.preventDefault();
      addToCart();
    });

    var thumbContainer = document.getElementById('thumbnail-container');
    if (thumbContainer) {
      thumbContainer.querySelectorAll('button').forEach(function(btn, i) {
        btn.addEventListener('click', function() {
          state.currentImageIndex = i + state.thumbnailOffset;
          updateGallery();
        });
      });
    }

    var scrollThumbBtn = document.getElementById('scroll-thumbnails-btn');
    if (scrollThumbBtn) {
      scrollThumbBtn.addEventListener('click', function() {
        var images = getProduct().images;
        var maxOffset = Math.max(0, images.length - VISIBLE_THUMBS);
        state.thumbnailOffset = Math.min(state.thumbnailOffset + VISIBLE_THUMBS, maxOffset);
        updateGallery();
      });
    }

    var scrollThumbLeftBtn = document.getElementById('scroll-thumbnails-left-btn');
    if (scrollThumbLeftBtn) {
      scrollThumbLeftBtn.addEventListener('click', function() {
        state.thumbnailOffset = Math.max(state.thumbnailOffset - VISIBLE_THUMBS, 0);
        updateGallery();
      });
    }

    var prevBtn = document.getElementById('prev-image-btn');
    var nextBtn = document.getElementById('next-image-btn');
    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        var images = getProduct().images;
        state.currentImageIndex = (state.currentImageIndex - 1 + images.length) % images.length;
        updateGallery();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        var images = getProduct().images;
        state.currentImageIndex = (state.currentImageIndex + 1) % images.length;
        updateGallery();
      });
    }

    var dotsContainer = document.getElementById('dot-indicators');
    if (dotsContainer) {
      dotsContainer.querySelectorAll('button').forEach(function(dot, i) {
        dot.addEventListener('click', function() {
          state.currentImageIndex = i;
          updateGallery();
        });
      });
    }

    initVideos();
    initFAQ();
    initScrollButtons();

    updateAllPrices();
    updateGallery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
